import { Component } from '@angular/core';

@Component({
  selector: 'hb-404',
  template: `
    <article class="template animated slideInRight">
      <h4>Invalid Request</h4>
      <div>This could be due to a typo, or missing parts of the URL.</div>
    </article>
  `,
})
export class PageNotFoundComponent { }